import { RoleType } from '../enums/role-type.enum';

/** Matches Admin role from API (Admin) and legacy seed (Administrator). */
export function isAdminRole(roleName: string | null | undefined): boolean {
  const role = roleName?.toLowerCase() ?? '';
  return role === RoleType.Admin || role === 'administrator';
}
